/* eslint-disable global-require */
import { memo, useMemo } from 'react';
import Image from 'next/image';
import { ContainerLayout } from '@layouts';
import classNames from 'classnames';
import { IMediaSideContentProps } from './MediaSideContent.types';
import styles from './styles.module.scss';

export const MediaSideContent = memo<IMediaSideContentProps>(
  ({ index, title, content, src, isLastItem }) => {
    const indexLabel = useMemo(() => {
      if (index < 10) {
        return `0${index}`;
      }

      return `${index}`;
    }, []);

    return (
      <ContainerLayout
        outerContainerClassName={styles.outerContainer}
        innerContainerClassName={classNames(styles.innerContainer, {
          [styles.modLast]: isLastItem,
        })}
      >
        <div className={styles.content}>
          <span className={styles.index}>{indexLabel}</span>
          <h3>{title}</h3>
          <p>{content}</p>
        </div>
        <Image className={styles.image} src={src} alt="" />
      </ContainerLayout>
    );
  },
);

MediaSideContent.displayName = 'MediaSideContent';

export default MediaSideContent;
